// ผังองค์กรทีม AI Agent — ถอดจากนิยาม agent ใน .claude/agents/*.md (15 ตำแหน่ง)
// โครงเป็นแมทริกซ์: แกนตั้ง = ระดับตำแหน่ง (rank), แกนนอน = ส่วนงาน (division)
// ถ้าเพิ่ม/แก้ agent ให้มาแก้ไฟล์นี้ไฟล์เดียว หน้าผังองค์กรจะอัปเดตตาม

// ส่วนงาน (คอลัมน์ของแมทริกซ์) — สีอิงชุดสีป้ายตำแหน่งใน PositionBadge
export const orgDivisions = [
  {
    key: "product",
    label: "Product & Architecture",
    labelTh: "ผลิตภัณฑ์และสถาปัตยกรรม",
    icon: "fa-compass-drafting",
    color: "#4a45ad",
    soft: "#eeedff",
    glow: "rgba(112, 106, 224, 0.32)",
    gradient: "linear-gradient(135deg, #6b66d6 0%, #4a45ad 100%)",
  },
  {
    key: "engineering",
    label: "Engineering",
    labelTh: "พัฒนาระบบ",
    icon: "fa-code",
    color: "#0e7191",
    soft: "#e7f7fc",
    glow: "rgba(28, 158, 199, 0.32)",
    gradient: "linear-gradient(135deg, #2aa4c9 0%, #0e7191 100%)",
  },
  {
    key: "quality",
    label: "Quality & Security",
    labelTh: "คุณภาพและความปลอดภัย",
    icon: "fa-shield-halved",
    color: "#b6497a",
    soft: "#fff0f6",
    glow: "rgba(214, 92, 140, 0.32)",
    gradient: "linear-gradient(135deg, #d9679a 0%, #b6497a 100%)",
  },
  {
    key: "platform",
    label: "Platform & Operations",
    labelTh: "แพลตฟอร์มและปฏิบัติการ",
    icon: "fa-server",
    color: "#137a52",
    soft: "#eafaf2",
    glow: "rgba(40, 168, 116, 0.32)",
    gradient: "linear-gradient(135deg, #2fb37c 0%, #137a52 100%)",
  },
];

// ระดับตำแหน่ง (แถวของแมทริกซ์) เรียงจากสูงไปต่ำ
export const orgRanks = [
  { key: "L1", label: "Leadership", labelTh: "ผู้นำทีม", hint: "วางแผน มอบหมาย และรวบรวมงานทั้งทีม" },
  { key: "L2", label: "Principal", labelTh: "กำหนดทิศทาง", hint: "ตัดสินใจว่าจะสร้างอะไร และโครงระบบเป็นอย่างไร" },
  { key: "L3", label: "Senior", labelTh: "เจ้าของโดเมน", hint: "รับผิดชอบงานด้านใดด้านหนึ่งตั้งแต่ต้นจนจบ" },
  { key: "L4", label: "Specialist", labelTh: "ผู้เชี่ยวชาญเฉพาะทาง", hint: "ตรวจสอบ แก้ไข และสนับสนุนให้คุณภาพได้มาตรฐาน" },
];

// รายชื่อ agent ทั้งหมด
export const orgAgents = [
  {
    id: "tech-lead",
    title: "Tech Lead",
    titleTh: "หัวหน้าทีมวิศวกรรม",
    division: null, // คุมทุกส่วนงาน
    rank: "L1",
    model: "opus",
    icon: "fa-crown",
    tools: ["Read", "Grep", "Glob", "Bash"],
    summary: "แปลงโจทย์ที่คลุมเครือเป็นแผนงานชัดเจน แตกงานเป็นขั้นตอน แล้วมอบหมายให้ผู้เชี่ยวชาญที่เหมาะสม",
    useWhen: "เริ่มงานที่ไม่ใช่เรื่องเล็ก ๆ ทุกครั้ง เพื่อวางแผนก่อนเขียนโค้ด และประสานงานเมื่อต้องใช้หลาย agent ร่วมกัน",
    duties: [
      "ชี้แจงเป้าหมายและนิยามคำว่า “เสร็จ” ใน 1–2 ประโยค",
      "สำรวจโค้ดเบสให้พอรู้ไฟล์ pattern และข้อจำกัดจริง",
      "แตกงานเป็นขั้นตอนตามลำดับ และมอบให้ผู้เชี่ยวชาญที่ควรเป็นเจ้าของ",
      "จัดลำดับเพื่อความปลอดภัย: ออกแบบ → สร้าง → ทดสอบ → ตรวจความปลอดภัย → รีวิว → เตรียมดีพลอย",
      "ส่งมอบงานชัดเจน: เป้าหมาย ไฟล์ที่เกี่ยวข้อง และนิยาม “เสร็จ” ของแต่ละขั้น",
    ],
    boundary: "วางแผน มอบหมาย และรวบรวมผล ไม่เขียนโค้ดส่วนใหญ่ด้วยตัวเอง และไม่ให้ agent หนึ่งทำงานแทนอีกคน",
  },
  {
    id: "product-analyst",
    title: "Product Analyst",
    titleTh: "นักวิเคราะห์ผลิตภัณฑ์",
    division: "product",
    rank: "L2",
    model: "sonnet",
    icon: "fa-lightbulb",
    tools: ["Read", "Write", "Grep", "Glob"],
    summary: "แปลงคำขอฟีเจอร์ที่คลุมเครือให้เป็น requirement ที่ทดสอบได้ ทั้ง user story เกณฑ์การยอมรับ ขอบเขต และ edge case",
    useWhen: "ตอนเริ่มต้นฟีเจอร์ ก่อนออกแบบหรือเขียนโค้ด และทุกครั้งที่คำขอกำกวม ขัดแย้ง หรือยังไม่มีเกณฑ์ความสำเร็จ",
    duties: [
      "เขียน problem statement: ใครมีปัญหาอะไร และทำไมถึงสำคัญ",
      "เขียน user story และ acceptance criteria แบบ Given/When/Then",
      "กำหนดขอบเขตที่ทำและไม่ทำให้ชัด",
      "ไล่ edge case และ failure mode: สถานะว่าง ขีดจำกัด สิทธิ์ และกรณีผิดพลาด",
      "รวบรวมคำถามที่ต้องให้มนุษย์ตัดสินใจ พร้อมข้อเสนอแนะ",
    ],
    boundary: "กำหนดความต้องการเท่านั้น ไม่เขียนโค้ด production และไม่ตัดสินใจด้านสถาปัตยกรรม",
  },
  {
    id: "solution-architect",
    title: "Solution Architect",
    titleTh: "สถาปนิกระบบ",
    division: "product",
    rank: "L2",
    model: "opus",
    icon: "fa-diagram-project",
    tools: ["Read", "Write", "Grep", "Glob"],
    summary: "ตัดสินใจโครงสร้างระดับระบบ ขอบเขต component การไหลของข้อมูล และการเลือกเทคโนโลยี พร้อมบันทึกเหตุผลเป็น ADR",
    useWhen: "เริ่มบริการหรือฟีเจอร์ใหญ่ ต้องเลือกระหว่างหลายแนวทาง หรือการตัดสินใจนั้นย้อนกลับได้ยาก",
    duties: [
      "เริ่มจากข้อจำกัดจริง: สเกล latency ขนาดทีม กำหนดส่ง และ stack ที่มีอยู่",
      "วาดแผนที่ระบบ: component หน้าที่ การไหลของข้อมูล และจุดเก็บ state",
      "เสนอ 2–3 ทางเลือกพร้อม trade-off ตรงไปตรงมา แล้วฟันธงหนึ่งทาง",
      "เขียน ADR สั้น ๆ: บริบท ทางเลือก การตัดสินใจ และผลที่ตามมา",
    ],
    boundary: "ออกแบบและบันทึกเหตุผล ไม่ลงมือสร้างระบบเอง ส่งพิมพ์เขียวให้วิศวกรต่อ",
  },
  {
    id: "api-designer",
    title: "API Designer",
    titleTh: "ผู้ออกแบบ API",
    division: "product",
    rank: "L3",
    model: "sonnet",
    icon: "fa-plug",
    tools: ["Read", "Write", "Edit", "Grep", "Glob"],
    summary: "ออกแบบและรีวิวสัญญา API ทั้ง endpoint schema ของ request/response status code versioning และรูปแบบ error",
    useWhen: "เพิ่ม endpoint ใหม่ เปลี่ยนรูปแบบ payload หรือกำหนดวิธีคุยกันระหว่างสองบริการ",
    duties: [
      "เริ่มจากผู้เรียกใช้: interface ที่เล็กและชัดที่สุดที่ตอบโจทย์",
      "นิยาม contract ให้ครบ: method path schema status code และรูปแบบ error",
      "ใช้ convention เดิมของโค้ดเบส: การตั้งชื่อ pagination และ error envelope",
      "ชี้ breaking change ทุกจุดให้เห็นชัด และทำให้การ retry ปลอดภัย",
    ],
    boundary: "ออกแบบและเขียน contract ไม่เขียน handler logic เอง",
  },
  {
    id: "database-engineer",
    title: "Database Engineer",
    titleTh: "วิศวกรฐานข้อมูล",
    division: "engineering",
    rank: "L3",
    model: "sonnet",
    icon: "fa-database",
    tools: ["Read", "Write", "Edit", "Bash", "Grep", "Glob"],
    summary: "ดูแล schema การ migrate การทำ index และประสิทธิภาพ query ทุกการเปลี่ยนแปลงต้องย้อนกลับได้",
    useWhen: "เพิ่มหรือแก้ตาราง เขียน migration หรือเมื่อ query ช้า และต้องผ่านก่อน schema ใด ๆ ขึ้น production",
    duties: [
      "ออกแบบ schema จากรูปแบบการอ่าน/เขียนจริง ไม่ใช่จากแผนผังลอย ๆ",
      "migration ทุกตัวต้องมี rollback ที่ทดสอบแล้ว และไม่ล็อกตารางใหญ่",
      "เพิ่ม index ให้ตรง query จริง และถอดตัวที่มีแต่ต้นทุนการเขียน",
      "อ่าน execution plan ก่อนแก้ query ช้า แล้วรายงานก่อน/หลัง",
    ],
    boundary: "ออกแบบและตรวจ migration แต่ไม่รันกับฐานข้อมูล production เอง ส่งให้มนุษย์หรือ devops ดำเนินการ",
  },
  {
    id: "frontend-engineer",
    title: "Frontend Engineer",
    titleTh: "วิศวกรส่วนหน้า",
    division: "engineering",
    rank: "L3",
    model: "sonnet",
    icon: "fa-window-maximize",
    tools: ["Read", "Write", "Edit", "Bash", "Grep", "Glob"],
    summary: "สร้างและรีวิว UI ทั้ง component การจัดการ state สไตล์ responsive และการเข้าถึง (accessibility)",
    useWhen: "สร้างหรือแก้หน้าจอผู้ใช้ ต่อข้อมูลจาก API เข้า UI หรือแก้ปัญหา layout state และการเข้าถึง",
    duties: [
      "ใช้ framework pattern และระบบสไตล์เดิมของโปรเจกต์ ไม่เพิ่มไลบรารีตามใจ",
      "ครบทุกสถานะของหน้าจอ: loading ว่าง error และสำเร็จ",
      "state ต้องคาดเดาได้ น้อยที่สุด และอยู่ใกล้ที่ใช้",
      "accessibility เป็นข้อบังคับ: semantic HTML คีย์บอร์ด focus และ contrast",
    ],
    boundary: "สร้างและรีวิว frontend เท่านั้น ไม่แก้ backend contract หรือ logic ฝั่งเซิร์ฟเวอร์ แจ้ง api-designer เมื่อไม่ตรงกัน",
  },
  {
    id: "refactorer",
    title: "Refactorer",
    titleTh: "ผู้ปรับโครงสร้างโค้ด",
    division: "engineering",
    rank: "L4",
    model: "sonnet",
    icon: "fa-wand-magic-sparkles",
    tools: ["Read", "Edit", "Bash", "Grep", "Glob"],
    summary: "ปรับโครงสร้างภายในของโค้ดโดยพฤติกรรมต้องเหมือนเดิมทุกประการ ลดความซ้ำซ้อน คลายความซับซ้อน ตั้งชื่อให้ชัด",
    useWhen: "โค้ดเริ่มมีกลิ่น ไฟล์โตจนคุมยาก หรือก่อนต่อยอดฟีเจอร์บนฐานที่ไม่มั่นคง ต้องมีเทสต์ก่อนเสมอ",
    duties: [
      "ยืนยันว่ามีเทสต์ครอบคลุมและผ่านก่อนเริ่ม ถ้าไม่มีให้หยุดแล้วส่งต่อ test-engineer",
      "เปลี่ยนทีละขั้นที่มีชื่อเรียก: extract rename inline ลดซ้ำ แยก god-object",
      "รันเทสต์หลังทุกขั้น ถ้าแดงให้ revert แล้วคิดใหม่",
      "เล็งที่ความซ้ำ ฟังก์ชันทำหลายอย่าง nesting ลึก และชื่อที่ชวนเข้าใจผิด",
    ],
    boundary: "ไม่เพิ่มฟีเจอร์หรือแก้บั๊กระหว่าง refactor และไม่เปลี่ยน public API โดยไม่แจ้ง",
  },
  {
    id: "security-auditor",
    title: "Security Auditor",
    titleTh: "ผู้ตรวจสอบความปลอดภัย",
    division: "quality",
    rank: "L3",
    model: "sonnet",
    icon: "fa-user-shield",
    tools: ["Read", "Grep", "Glob", "Bash"],
    summary: "ตรวจหาช่องโหว่ทั้ง injection ข้อบกพร่องด้าน auth การรั่วของ secret dependency ที่เสี่ยง และการเปิดเผยข้อมูล",
    useWhen: "ก่อนส่งมอบสิ่งที่รับ input จากผู้ใช้ การยืนยันตัวตน การชำระเงิน หรือข้อมูลส่วนบุคคล และทุกครั้งที่แตะ auth หรือ upload ไฟล์",
    duties: [
      "ไล่ตาม input ที่ไม่น่าเชื่อถือจากจุดเข้าไปถึงปลายทาง ไม่ใช่แค่ค้นคำ",
      "ตรวจตามลำดับ: injection → auth/authorization → secret → ข้อมูลอ่อนไหว → dependency → misconfiguration",
      "ทุก finding ต้องมี exploit scenario ที่ทำได้จริง และระดับความรุนแรงที่ตรงไปตรงมา",
      "รายงาน: ช่องโหว่ ตำแหน่ง ผลกระทบ และวิธีแก้พร้อมตัวอย่างโค้ด",
    ],
    boundary: "ตรวจและแนะนำเท่านั้น ไม่ push การแก้ขึ้น production เอง และไม่ลดทอน control เพื่อให้ระบบทำงาน",
  },
  {
    id: "code-reviewer",
    title: "Code Reviewer",
    titleTh: "ผู้รีวิวโค้ด",
    division: "quality",
    rank: "L4",
    model: "sonnet",
    icon: "fa-magnifying-glass-chart",
    tools: ["Read", "Grep", "Glob", "Bash"],
    summary: "รีวิวการเปลี่ยนแปลงโค้ดด้านความถูกต้อง อ่านง่าย และดูแลต่อได้ จับปัญหาตั้งแต่ตอนที่แก้ยังถูก",
    useWhen: "ทันทีหลังเขียนหรือแก้โค้ดชุดหนึ่ง ก่อน commit และต้องผ่านก่อนเปิด pull request ทุกครั้ง",
    duties: [
      "รีวิวจาก diff ที่เปลี่ยนจริง อ่านบริบทรอบ ๆ ให้เข้าใจเจตนาก่อนตัดสิน",
      "ลำดับความสำคัญ: ความถูกต้อง → ความปลอดภัยของการเปลี่ยน → อ่านง่าย → เทสต์ → ความสม่ำเสมอ",
      "จัดกลุ่มตามความรุนแรง: ต้องแก้ ควรแก้ และพิจารณา",
      "อ้างไฟล์และบรรทัดทุกข้อ ไม่สร้างปัญหาขึ้นมาเพื่อให้ดูละเอียด",
    ],
    boundary: "รีวิวและให้คำแนะนำ ไม่ commit push หรือแก้ไฟล์ด้วยตัวเอง",
  },
  {
    id: "test-engineer",
    title: "Test Engineer",
    titleTh: "วิศวกรทดสอบ",
    division: "quality",
    rank: "L4",
    model: "sonnet",
    icon: "fa-vial-circle-check",
    tools: ["Read", "Write", "Edit", "Bash", "Grep", "Glob"],
    summary: "เขียนและรันเทสต์อัตโนมัติ วินิจฉัยเทสต์ที่ล้มเหลว และเพิ่ม coverage บนเส้นทางสำคัญ",
    useWhen: "หลังทำฟีเจอร์หรือแก้บั๊กเสร็จ เพื่อล็อกพฤติกรรมไว้ และทุกครั้งที่ test suite พัง",
    duties: [
      "อ่าน implementation แล้วระบุ contract: input output side effect และเงื่อนไข error",
      "ใช้ framework และ convention เดิมของโปรเจกต์",
      "ครอบคลุม happy path → ขอบเขต (ว่าง null สูงสุด off-by-one) → กรณีล้มเหลว",
      "ไม่มีเทสต์ flaky: ไม่ใช้ network นาฬิกา หรือสุ่มจริง",
    ],
    boundary: "ไม่แก้ production logic เพื่อให้เทสต์ผ่านโดยไม่แจ้ง และไม่ลดทอน assertion เพื่อซ่อนบั๊ก",
  },
  {
    id: "debugger",
    title: "Debugger",
    titleTh: "ผู้วิเคราะห์ต้นตอบั๊ก",
    division: "quality",
    rank: "L4",
    model: "sonnet",
    icon: "fa-bug",
    tools: ["Read", "Edit", "Bash", "Grep", "Glob"],
    summary: "หาต้นตอที่แท้จริงของบั๊ก crash และ exception ด้วยการทำซ้ำ แยกส่วน และแก้ที่สาเหตุ ไม่ใช่อาการ",
    useWhen: "ทันทีที่มี error stack trace หรือ assertion ล้มเหลว",
    duties: [
      "Capture: อ่าน error และ stack trace ให้ครบ ไม่ใช่แค่ frame บนสุด",
      "Reproduce: หาวิธีทำซ้ำที่เล็กและเชื่อถือได้",
      "Isolate: ตั้งสมมติฐานแล้วทดสอบจนเหลือ component เดียว",
      "Fix → Verify → Clean up: แก้น้อยที่สุด ยืนยันว่าหาย แล้วเก็บ log ชั่วคราวออก",
    ],
    boundary: "ไม่แพตช์อาการ ไม่กลืน exception และไม่แก้ห้าอย่างพร้อมกันในการแก้บั๊กเดียว",
  },
  {
    id: "performance-engineer",
    title: "Performance Engineer",
    titleTh: "วิศวกรประสิทธิภาพ",
    division: "quality",
    rank: "L4",
    model: "sonnet",
    icon: "fa-gauge-high",
    tools: ["Read", "Edit", "Bash", "Grep", "Glob"],
    summary: "วินิจฉัยและแก้ปัญหาความช้า ทั้ง endpoint ช้า latency สูง memory โต และ throughput ต่ำ จากการวัดจริงเท่านั้น",
    useWhen: "เมื่อมีอะไร “ช้า” โหลดกำลังจะเพิ่ม หรือก่อนเปิดตัว",
    duties: [
      "ตั้ง baseline: ทำซ้ำเส้นทางที่ช้าแล้ววัด latency throughput memory CPU",
      "Profile หา bottleneck จริง ไม่ใช่จากสัญชาตญาณ",
      "แก้ตัวใหญ่สุดก่อน ทีละอย่าง แล้ววัดซ้ำ ถ้าตัวเลขไม่ขยับให้ revert",
      "รายงานตัวเลขก่อน/หลัง และ trade-off ของการ optimize",
    ],
    boundary: "ไม่แลกความถูกต้องกับความเร็วโดยไม่แจ้งชัดเจน และคง version ที่อ่านง่ายไว้ถ้าตัวเลขไม่คุ้ม",
  },
  {
    id: "devops-engineer",
    title: "DevOps Engineer",
    titleTh: "วิศวกร DevOps",
    division: "platform",
    rank: "L3",
    model: "sonnet",
    icon: "fa-rocket",
    tools: ["Read", "Write", "Edit", "Bash", "Grep", "Glob"],
    summary: "ดูแล CI/CD container ค่าคอนฟิกการดีพลอย และ infrastructure-as-code เป้าหมายคือดีพลอยที่น่าเบื่อ ทำซ้ำได้ และย้อนกลับได้เสมอ",
    useWhen: "ตั้งค่าหรือแก้ build pipeline ไฟล์ Docker/compose ค่า environment หรือ release automation และทุกครั้งที่ CI พังหรือดีพลอยล้มเหลว",
    duties: [
      "CI/CD: build test lint deploy พร้อม cache ล้มเร็ว และ log ที่อ่านรู้เรื่อง",
      "Container เล็กและทำซ้ำได้ pin เวอร์ชัน ไม่ฝัง secret",
      "แยก config ออกจากโค้ดอย่างเคร่งครัด ใช้ env และ secret manager",
      "เมื่อ pipeline พัง: อ่าน log จาก error แรก ทำซ้ำในเครื่อง แล้วแก้ที่ต้นเหตุ",
    ],
    boundary: "เตรียมและตรวจการเปลี่ยนแปลง แต่ไม่สั่งดีพลอย production หมุน secret หรือแก้สิทธิ์ production เอง",
  },
  {
    id: "observability-engineer",
    title: "Observability Engineer",
    titleTh: "วิศวกรระบบสังเกตการณ์",
    division: "platform",
    rank: "L3",
    model: "sonnet",
    icon: "fa-satellite-dish",
    tools: ["Read", "Write", "Edit", "Bash", "Grep", "Glob"],
    summary: "ติดตั้งเครื่องมือให้เห็นปัญหาบน production ได้ในไม่กี่นาที: structured log metric tracing health check และ alert ที่ลงมือทำได้",
    useWhen: "ส่งมอบบริการหรือเส้นทางสำคัญใหม่ หลัง incident เผยจุดบอด หรือเมื่อทีมพูดว่า “ไม่รู้ว่าเกิดอะไรขึ้นบน prod”",
    duties: [
      "ระบุเส้นทางวิกฤตและโหมดล้มเหลวที่เจ็บที่สุด แล้วติดตั้งตรงนั้นก่อน",
      "Log แบบมีโครงสร้าง มี correlation id ไม่ log secret หรือข้อมูลส่วนบุคคล",
      "Metric สัญญาณทอง: latency traffic error saturation",
      "Alert ต้องลงมือทำได้: ดังเมื่อผู้ใช้รู้สึก ชี้สาเหตุที่น่าจะเป็น และไม่ร้องหมาป่า",
    ],
    boundary: "เพิ่ม instrumentation และนิยาม alert แต่ไม่ตั้งค่าแพลตฟอร์ม monitoring หรือเปลี่ยนเส้นทาง alert บน production เอง",
  },
  {
    id: "technical-writer",
    title: "Technical Writer",
    titleTh: "นักเขียนเอกสารเทคนิค",
    division: "platform",
    rank: "L4",
    model: "sonnet",
    icon: "fa-book-open",
    tools: ["Read", "Write", "Edit", "Grep", "Glob"],
    summary: "เขียนและดูแลเอกสารสำหรับนักพัฒนา: README เอกสาร API คู่มือติดตั้ง/onboarding changelog และบันทึกสถาปัตยกรรม",
    useWhen: "หลังฟีเจอร์นิ่งแล้ว เมื่อคนใหม่เข้าทีมติดขัด หรือเอกสารไม่ตรงกับโค้ด และต้องใช้ทุกครั้งที่ public API หรือขั้นตอนติดตั้งเปลี่ยน",
    duties: [
      "อ่านโค้ด config และเทสต์จริงก่อนเขียนทุกคำ",
      "เขียนให้ผู้อ่านเฉพาะกลุ่ม: ผู้ร่วมพัฒนาใหม่ ผู้ใช้ API หรือผู้ดูแลระบบ",
      "นำด้วยสิ่งที่ผู้อ่านต้องทำ แล้วค่อยอธิบายเหตุผล ทุกคำสั่งต้องรันได้จริง",
      "เมื่อโค้ดกับเอกสารขัดกัน โค้ดชนะ แก้เอกสารแล้วแจ้งความผิดปกติ",
    ],
    boundary: "เขียนเอกสารเท่านั้น ไม่แก้ logic ของแอป ถ้าโค้ดสับสนจนต้องอธิบายยาว ให้ชี้ไปที่ refactorer",
  },
];

export const orgModelMeta = {
  opus: { label: "Opus", hint: "โมเดลระดับสูงสำหรับงานตัดสินใจและวางแผน", color: "#8a6212", bg: "linear-gradient(135deg, #fff6dc 0%, #f7dda0 100%)", border: "rgba(184, 138, 32, 0.42)" },
  sonnet: { label: "Sonnet", hint: "โมเดลสมดุลสำหรับงานเฉพาะทาง", color: "#0b5cb5", bg: "linear-gradient(135deg, #eef6ff 0%, #d8e9ff 100%)", border: "rgba(12, 118, 229, 0.30)" },
};

// ลำดับการวางบนวงกลมในโหมด "เส้นทางส่งงาน" (เรียงตาม workflow: ออกแบบ → สร้าง → ทดสอบ → ตรวจ → รีวิว → ดีพลอย → เอกสาร)
export const orgRingOrder = [
  "product-analyst",
  "solution-architect",
  "api-designer",
  "database-engineer",
  "frontend-engineer",
  "refactorer",
  "test-engineer",
  "debugger",
  "performance-engineer",
  "security-auditor",
  "code-reviewer",
  "devops-engineer",
  "observability-engineer",
  "technical-writer",
];

// ใครส่งงานให้ใคร — ถอดจากประโยค hand-off ในแต่ละไฟล์ agent
// type: handoff = ส่งงานต่อตามลำดับ, feedback = แจ้งกลับ/ขอความช่วยเหลือ (วาดเป็นเส้นประ)
// tech-lead ไม่อยู่ในรายการนี้ เพราะมอบหมายให้ทุกตำแหน่ง (วาดเป็นเส้นจากจุดศูนย์กลาง)
export const orgHandoffs = [
  { from: "product-analyst", to: "solution-architect", label: "requirement ที่ทดสอบได้", type: "handoff" },
  { from: "product-analyst", to: "test-engineer", label: "acceptance criteria สำหรับเขียนเทสต์", type: "handoff" },
  { from: "solution-architect", to: "api-designer", label: "พิมพ์เขียวระบบและขอบเขต component", type: "handoff" },
  { from: "solution-architect", to: "database-engineer", label: "โครงข้อมูลและจุดเก็บ state", type: "handoff" },
  { from: "solution-architect", to: "frontend-engineer", label: "พิมพ์เขียวระบบฝั่ง UI", type: "handoff" },
  { from: "api-designer", to: "frontend-engineer", label: "สัญญา API ให้ UI เรียกใช้", type: "handoff" },
  { from: "api-designer", to: "database-engineer", label: "contract ให้ implement ฝั่งข้อมูล", type: "handoff" },
  { from: "api-designer", to: "technical-writer", label: "API เปลี่ยน → อัปเดตเอกสาร", type: "handoff" },
  { from: "frontend-engineer", to: "api-designer", label: "แจ้ง contract ไม่ตรงกับหน้าจอ", type: "feedback" },
  { from: "frontend-engineer", to: "test-engineer", label: "หน้าจอที่เสร็จแล้วให้ทดสอบ", type: "handoff" },
  { from: "database-engineer", to: "test-engineer", label: "schema/query ให้ทดสอบ", type: "handoff" },
  { from: "database-engineer", to: "devops-engineer", label: "migration + rollback ที่ตรวจแล้วให้รัน", type: "handoff" },
  { from: "performance-engineer", to: "database-engineer", label: "query/index ที่เป็นคอขวด", type: "feedback" },
  { from: "refactorer", to: "test-engineer", label: "ขอเทสต์ครอบคลุมก่อน refactor", type: "feedback" },
  { from: "test-engineer", to: "debugger", label: "เทสต์พังเพราะโค้ดผิด → หาต้นตอ", type: "handoff" },
  { from: "debugger", to: "test-engineer", label: "แก้บั๊กแล้ว → ล็อกพฤติกรรมด้วยเทสต์", type: "handoff" },
  { from: "test-engineer", to: "security-auditor", label: "ผ่านเทสต์ → ตรวจความปลอดภัย", type: "handoff" },
  { from: "security-auditor", to: "code-reviewer", label: "ผ่าน audit → รีวิวก่อน merge", type: "handoff" },
  { from: "observability-engineer", to: "security-auditor", label: "ปรึกษาเรื่อง PII/secret ใน log", type: "feedback" },
  { from: "code-reviewer", to: "devops-engineer", label: "ผ่านรีวิว → เตรียมดีพลอย", type: "handoff" },
  { from: "code-reviewer", to: "technical-writer", label: "ฟีเจอร์นิ่งแล้ว → เขียนเอกสาร", type: "handoff" },
  { from: "observability-engineer", to: "devops-engineer", label: "log/metric/alert ให้ติดตั้งบน production", type: "handoff" },
  { from: "devops-engineer", to: "technical-writer", label: "ขั้นตอนติดตั้งเปลี่ยน → อัปเดตคู่มือ", type: "handoff" },
  { from: "technical-writer", to: "refactorer", label: "โค้ดสับสนจนอธิบายยาก → ปรับโครงสร้าง", type: "feedback" },
];
